export interface Campaign {
  id: string;
  title: string;
  venueName: string;
  venueCategory: string;
  discountPct: number;
  description: string;
  image: string;
  expiresDate: string;
  couponCode: string;
  isSponsored: boolean;
  district: string;
}

export const campaigns: Campaign[] = [
  {
    id: "extrempark-30",
    title: "Tüm Aktivitelerde %30 İndirim",
    venueName: "Extrempark Bursa",
    venueCategory: "Eğlence",
    discountPct: 30,
    description: "Dağ kızağı, ipli parkurlar ve dev salıncakta geçerli özel yaz kampanyası.",
    image: "https://public.readdy.ai/ai/img_res/9e602150f902a476d41514c78d0de67f.jpg",
    expiresDate: "30 Nisan 2026",
    couponCode: "XTRM30",
    isSponsored: true,
    district: "Osmangazi",
  },
  {
    id: "hotel-early",
    title: "Erken Rezervasyonda %25 İndirim",
    venueName: "Gümüşpala Termal",
    venueCategory: "Konaklama",
    discountPct: 25,
    description: "15 gün önceden rezervasyon yapanlara özel oda fiyatı ve ücretsiz spa girişi.",
    image: "https://readdy.ai/api/search-image?query=thermal%20spa%20hotel%20early%20booking%20offer%20discount%20luxury%20pool%20promotion%20wellness%20Turkey%20warm%20elegant%20interior&width=500&height=320&seq=campaign002&orientation=landscape",
    expiresDate: "15 Mayıs 2026",
    couponCode: "ERKEN25",
    isSponsored: true,
    district: "Osmangazi",
  },
  {
    id: "cumalikizik-2plus1",
    title: "Kahvaltı 2 Alana 1 Bedava",
    venueName: "Cumalıkızık Köy Sofrası",
    venueCategory: "Lezzet",
    discountPct: 33,
    description: "Hafta sonu kahvaltılarında 2 kişi gelen 3. kişi için ücret alınmıyor.",
    image: "https://readdy.ai/api/search-image?query=traditional%20Turkish%20breakfast%20village%20stone%20house%20rustic%20table%20eggs%20cheese%20honey%20bread%20authentic%20warm%20morning%20Bursa%20countryside&width=500&height=320&seq=campaign003&orientation=landscape",
    expiresDate: "1 Haziran 2026",
    couponCode: "KAHVALTI3",
    isSponsored: false,
    district: "Yıldırım",
  },
  {
    id: "botanik-family",
    title: "Aile Paketi - Çocuklar Ücretsiz",
    venueName: "Bursa Botanik Parkı",
    venueCategory: "Doğa",
    discountPct: 50,
    description: "Her iki yetişkin bilete bir çocuk girişi ücretsiz. Piknik alanları dahil.",
    image: "https://readdy.ai/api/search-image?query=botanical%20garden%20park%20family%20children%20playing%20green%20nature%20park%20Turkey%20Bursa%20sunny%20day%20outdoor%20relaxing%20picnic%20area&width=500&height=320&seq=campaign004&orientation=landscape",
    expiresDate: "31 Mayıs 2026",
    couponCode: "AILE50",
    isSponsored: false,
    district: "Osmangazi",
  },
];
